import { useTheme } from '../../lib/theme';

export default function AdminThemeToggle() {
  const [theme, toggleTheme] = useTheme();
  const switchingToDark = theme === 'light';

  return (
    <button
      type="button"
      className="app-button grid h-9 w-9 place-items-center rounded-full border border-line bg-transparent text-muted transition-all duration-300 hover:border-fg/60 hover:bg-elevated hover:text-fg"
      onClick={toggleTheme}
      aria-label={switchingToDark ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {switchingToDark ? (
        <svg className="h-4 w-4" viewBox="0 0 20 20" aria-hidden="true">
          <path
            fill="currentColor"
            d="M16.7 13.15A7.25 7.25 0 0 1 6.85 3.3 7.26 7.26 0 1 0 16.7 13.15Z"
          />
        </svg>
      ) : (
        <svg className="h-4 w-4" viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="10" cy="10" r="3.25" fill="currentColor" />
          <path
            d="M10 1.5v2M10 16.5v2M1.5 10h2M16.5 10h2M3.99 3.99l1.42 1.42M14.59 14.59l1.42 1.42M16.01 3.99l-1.42 1.42M5.41 14.59l-1.42 1.42"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </svg>
      )}
    </button>
  );
}
